import { render, staticRenderFns } from "./WorldMenu.vue?vue&type=template&id=58ecc6dc&scoped=true"
import script from "./WorldMenu.vue?vue&type=script&lang=js"
export * from "./WorldMenu.vue?vue&type=script&lang=js"
import style0 from "./WorldMenu.vue?vue&type=style&index=0&id=58ecc6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../calendar/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ecc6dc",
  null
  
)

export default component.exports